import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { STOP_ANALYTICS_INITIATED_BY } from 'aria-viewer/tour/constants/index'
import { setStopInitiatedBy } from 'aria-viewer/analytics/analyticActions'

import { setStop } from 'aria-viewer/tour/tourActions'

export const previousStop = e => (dispatch, getState) => {
    if (isPrevStopEnabled()(dispatch, getState)) {
        const initiatedBy =
            e.type == 'keydown' ? STOP_ANALYTICS_INITIATED_BY.keyboard : STOP_ANALYTICS_INITIATED_BY.prev_button
        dispatch(setStopInitiatedBy(initiatedBy))

        const state = getState()

        const { stopIndex, stopsList } = mapSelectorsToProps(['stopIndex', 'stopsList'])()(state)
        const prevStopIndex = (stopIndex - 1 + stopsList.size) % stopsList.size
        dispatch(setStop(prevStopIndex))
    }
}

export const nextStop = e => (dispatch, getState) => {
    if (isNextStopEnabled()(dispatch, getState)) {
        const initiatedBy =
            e.type == 'keydown' ? STOP_ANALYTICS_INITIATED_BY.keyboard : STOP_ANALYTICS_INITIATED_BY.next_button
        dispatch(setStopInitiatedBy(initiatedBy))

        const state = getState()

        const { stopIndex, stopsList } = mapSelectorsToProps(['stopIndex', 'stopsList'])()(state)
        const nextStopIndex = (stopIndex + 1) % stopsList.size
        dispatch(setStop(nextStopIndex))
    }
}

export const isPrevStopEnabled = () => (dispatch, getState) => {
    const state = getState()
    const { endOfTourMessage, stopIndex } = mapSelectorsToProps(['stopIndex', 'endOfTourMessage'])()(state)

    return !endOfTourMessage || stopIndex != 0
}

export const isNextStopEnabled = () => (dispatch, getState) => {
    const state = getState()
    const { endOfTourMessage, stopIndex, stopsList } = mapSelectorsToProps([
        'stopIndex',
        'endOfTourMessage',
        'stopsList',
    ])()(state)

    return !endOfTourMessage || stopIndex != stopsList.size - 1
}
